<template>
  <ItemWrapper @openChildEditor="handleOpenChildEditor">
    <div class="photo-item">
      <div v-loading="!photoLoaded" class="photo-container">
        <img class="photo" :src="image.src" @load="onImageLoad"/>
      </div>
      <div v-if="detailLink.isActive" class="detail-mask">
        <div class="title" :class="!title && 'no-wrapper'">
          <div class="title-text" ref="titleEl">{{ title }}</div>
        </div>
        <div class="detail-btn">
          <span @click="handleClick">{{ $t('microSite.photoWall.view') }}</span>
        </div>
      </div>
    </div>
  </ItemWrapper>
</template>

<script>
import ItemWrapper from '../../../components/render/itemWrapper'
import { childName } from '../index'
import { mapGetters } from 'vuex'
import { mixedRouterPush } from '@/router/routes'
import { appendSourceCode } from '@/utils/common'

export default {
  components: {
    ItemWrapper
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    renderMode: {
      type: String,
      required: true
    },
    image: {
      type: Object,
      required: true
    },
    detailLink: {
      type: Object,
      required: true
    },
    styleConfig: {
      type: Object,
      required: false
    }
  },
  data () {
    return {
      photoLoaded: false
    }
  },
  computed: {
    ...mapGetters('microSite', ['isEditMode', 'currentPage', 'pagePathPrefix'])
  },
  created () {

  },
  methods: {
    onImageLoad ($event) {
      this.photoLoaded = true
    },
    handleOpenChildEditor () {
      this.$emit('openChildEditor', {
        editorName: childName,
        fromChild: true
      })
    },
    handleClick () {
      if (!this.detailLink.isActive) {
        return
      }
      this.detailLink.url = this.detailLink.url.trim()
      if (this.detailLink.url.startsWith('/v/onboarding/questionnaire')) {
        this.$eventBus.$emit('openOnboardingQuestionnairePage', this.clickLink.openNewWindow)
        return
      }
      let targetUrl = null
      if (this.detailLink.isInnerPage) {
        targetUrl = this.pagePathPrefix + this.detailLink.url
      } else {
        targetUrl = this.detailLink.url
      }
      targetUrl = appendSourceCode(targetUrl)
      if (this.detailLink.openNewWindow) {
        window.open(targetUrl)
      } else {
        if (this.detailLink.isInnerPage) {
          this.$router.push(targetUrl)
        } else {
          mixedRouterPush(targetUrl)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.photo-item {
  padding: 10px;
  position: relative;

  &:hover {
    .detail-mask {
      display: block;
    }
  }

  .detail-mask {
    display: none;
    width: calc(100% - 21px);
    height: calc(100% - 25px);
    background: rgba($color: #000000, $alpha: 0.5);
    position: absolute;
    top: 10px;
    left: 10px;

    .title {
      margin-top: 65px;
    }

    .detail-btn {
      width: 55px;
      height: 25px;
      line-height: 25px;
      margin: 40px auto 0;
      border: 1px solid #ffffff;
      color: #ffffff;
      cursor: pointer;
    }
  }

  .photo-container {
    .photo {
      display: block;
    }
  }
}
</style>
